import { render, staticRenderFns } from "./PrintTransaction.vue?vue&type=template&id=96377c2a&scoped=true"
import script from "./PrintTransaction.vue?vue&type=script&lang=js"
export * from "./PrintTransaction.vue?vue&type=script&lang=js"
import style0 from "./PrintTransaction.vue?vue&type=style&index=0&id=96377c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96377c2a",
  null
  
)

export default component.exports